(() => {
  const swapFromHtml = (html, id) => {
    const current = document.getElementById(id);
    const fresh = html?.getElementById(id);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };

  if (!customElements.get('op-bundle-selector')) {
    customElements.define(
      'op-bundle-selector',
      class OpBundleSelector extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.onChange.bind(this));
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (data?.sectionId !== this.dataset.section) return;
              swapFromHtml(data.html, this.id);
            });
          }
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        onChange(event) {
          const radio = event.target.closest('.op-bundle__input');
          if (!radio) return;
          event.stopPropagation();

          this.querySelectorAll('.op-bundle__option').forEach((option) =>
            option.classList.toggle('is-selected', option.contains(radio))
          );

          const productInfo = this.closest('product-info');
          const variantSelects = productInfo?.querySelector('variant-selects');
          const optionName = this.dataset.optionName;

          if (variantSelects) {
            const pill = Array.from(variantSelects.querySelectorAll('input[type="radio"]')).find(
              (input) => input.dataset.optionName === optionName && input.value === radio.value
            );
            if (pill) {
              pill.checked = true;
              pill.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
            const select = Array.from(variantSelects.querySelectorAll('select')).find((el) =>
              Array.from(el.options).some((o) => o.dataset.optionName === optionName)
            );
            if (select) {
              select.value = radio.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }

          // No variant picker block on the page: fall back to a full reload of the chosen variant.
          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.dataset.variantId);
          window.location.assign(url.toString());
        }
      }
    );
  }

  if (!customElements.get('op-sticky-atc')) {
    customElements.define(
      'op-sticky-atc',
      class OpStickyAtc extends HTMLElement {
        connectedCallback() {
          const section = this.dataset.section;
          this.submitButton = () => document.getElementById(`ProductSubmitButton-${section}`);
          this.target = document.querySelector(`#MainProduct-${section} product-form`) || this.submitButton();

          this.querySelector('[data-op-sticky-submit]')?.addEventListener('click', () => {
            const button = this.submitButton();
            if (!button) return;
            if (button.disabled) {
              button.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            button.click();
          });

          if (this.target && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(([entry]) => {
              const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.hidden = !passed;
              document.body.classList.toggle('op-sticky-visible', passed);
            });
            this.observer.observe(this.target);
          }

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
              if (data?.sectionId !== section) return;
              swapFromHtml(data.html, `op-sticky-price-${section}`);
            });
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.unsubscribe?.();
          document.body.classList.remove('op-sticky-visible');
        }
      }
    );
  }
})();
